import React from "react"
import slugify from "slugify"
import { Section, SingleExpertContent } from "@alexanderathoodly/ui-library"
import { BlockFooter } from "../blockfooter"
import { ExtendedExpertInfo } from "../../settings/team"
import { createButtonWithAnalitics, sendEngagementEvent } from "../../analytics/actions"
import { CommonBlockProps, GaButtonProps } from "../types"
import { getIconPath } from "../../helpers/getIconPath"
import teamdata from "../../data/team-data.json"

export interface SingleExpertProps extends CommonBlockProps {
    template: "single-expert"
    expertname: string
    button?: GaButtonProps
    description: { heading: string; text: string }
}

const SingleExpert = ({
    id,
    color,
    icon = "profile",
    expertname,
    button,
    description,
    label,
    headline,
    footertext,
    buttons,
    ...rest
}: SingleExpertProps): JSX.Element => {
    const onClickPhone = (): void => {
        sendEngagementEvent("click_expert_phone")
    }
    const onClickEmail = (): void => {
        sendEngagementEvent("click_expert_email")
    }
    return (
        <Section
            id={id || undefined}
            className="single-expert-section"
            shape="shape5"
            backgroundColor={color}
            icon={getIconPath(icon)}
            label={label}
            headline={headline}
            {...rest}
        >
            {expertname && (
                <SingleExpertContent
                    expert={teamdata.members.find((expert) => expert.fullName === expertname) as ExtendedExpertInfo}
                    description={description}
                    button={button ? createButtonWithAnalitics(button, slugify(headline)) : undefined}
                    onClickPhone={onClickPhone}
                    onClickEmail={onClickEmail}
                />
            )}
            <BlockFooter footertext={footertext} buttons={buttons} position={headline} />
        </Section>
    )
}

export { SingleExpert }
